import { memo, useCallback } from 'react'
import Icon from 'builder/components/Icon'
import { i18n as I18n } from 'builder/utils/i18n'
import { DownloadButton } from 'builder/components/PreviewPanel'
import { TooltipInfoWrapper } from 'builder/components/PreviewPanel/components/TooltipInfoWrapper/TooltipInfoWrapper'

import { selectors } from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import {
  Buttons,
  BackButton,
  BackWrapper,
  BackButtonIcon,
  MobileTemplateSettingsIcon,
  Toolbar,
} from './styles'
import { PreviewToolbarProps } from './types'

const PreviewToolbar = (props: PreviewToolbarProps) => {
  const autoTailoringFromPublicJobBoard = useTypedSelector(
    selectors.autoTailoringFromPublicJobBoard,
  )

  const {
    isDownloading,
    isSheetVisible,
    handleSheetOpen,
    handleSheetClose,
    handleDownloadDocument,
    handleShareDocument,
    handleCombineDocuments,
    onClose,
    showResumeDistributionModal,
    handleDownloadButtonMenuOpen,
  } = props

  const handleSheetToggle = useCallback(() => {
    if (isSheetVisible) {
      handleSheetClose()
    } else {
      handleSheetOpen()
    }
  }, [handleSheetClose, handleSheetOpen, isSheetVisible])

  return (
    <Toolbar>
      <BackWrapper>
        <BackButton onClick={onClose}>
          <BackButtonIcon />
          <span>{I18n.t('builder.resume_editor.edit')}</span>
        </BackButton>
      </BackWrapper>
      <Buttons>
        {autoTailoringFromPublicJobBoard.enabled ? null : (
          <DownloadButton
            handleDownloadDocument={handleDownloadDocument}
            handleShareDocument={handleShareDocument}
            handleDownloadButtonMenuOpen={handleDownloadButtonMenuOpen}
            isDownloading={isDownloading}
            showResumeDistributionModal={showResumeDistributionModal}
            handleCombineDocuments={handleCombineDocuments}
          />
        )}
      </Buttons>
      <TooltipInfoWrapper
        position="bottom"
        tooltip={I18n.t(`builder.resume_editor.change_template_tooltip`)}
      >
        <MobileTemplateSettingsIcon onClick={handleSheetToggle}>
          <Icon.Settings />
        </MobileTemplateSettingsIcon>
      </TooltipInfoWrapper>
    </Toolbar>
  )
}

export default memo(PreviewToolbar)
